// ============================================================================
// zonaESigurt.js — sa hapësirë lë prerja e ekranit, dhe pse nuk i besohet.
//
// 29 gusht 2026. Pronari: «trungu im prapë nuk është mirë në iPhone».
//
// ÇFARË U MAT. Te iPhone 16 Pro (402×874pt), koka e dritares «Shiko» dilte
// rreth 229pt e lartë, kur duhej rreth 101pt. Titulli nuk ishte i shtyrë poshtë
// nga ndonjë element: e shtynte vetë `padding-top`-i. Zona e sigurt e atij
// aparati është 62pt; ne po merrnim rreth 186.
//
//     62 × 3 = 186 — pikërisht raporti i pikselave të atij ekrani.
//
// Pra vlera po vjen në PIKSELA PAJISJEJE, kurse CSS-ja e lexon si pikë.
//
// ─────────────────────────────────────────────────────────────────────────────
// PSE NUK MJAFTOI KAPAKU NË CSS.
//
// Provën e parë e bëra me `min(…, 64px)` brenda vetë vargut CSS. Ajo ka dy
// dobësi që i pashë vetëm pasi pronari tha «prapë nuk u rregullua»:
//
//   1. `min()` që përmban `var()` që përmban `env()` është tri nivele thellë.
//      Nëse ndonjë WebView e refuzon atë varg, shfletuesi nuk e kap gabimin —
//      e hedh poshtë TË GJITHË deklaratën. Rezultati s'është «pak më ndryshe»;
//      është «asnjë hapësirë fare», dhe teksti hyn nën prerje.
//   2. Kapaku jep 64, kurse e vërteta është 62. Të afërt, po jo të njëjtë.
//
// PRANDAJ RREGULLIMI ZHVENDOSET NGA CSS-JA TE KODI. Ne e MASIM vlerën një
// herë, e gjykojmë, dhe pastaj e SHKRUAJMË vetë `--safe-area-inset-top`. Meqë
// çdo vend në aplikacion e lexon `var(--safe-area-inset-top, env(…))`, dhe
// `var()` fiton kur ekziston, vlera jonë e korrigjuar zbatohet kudo pa u
// prekur asnjë rresht tjetër. Vargu CSS kthehet në formën e tij më të thjeshtë
// e më të përputhshme — pa `min()`, pa nivel të tretë.
//
// SI GJYKOHET NJË VLERË. Zona e sigurt lart është 20pt te aparatet pa prerje,
// 44–48pt me prerje, 59–62pt me Dynamic Island. Poshtë: 0 ose 34pt te iOS,
// deri ~48pt te Androidi. Mbi këto s'ka aparat. Pra:
//
//   · brenda kufirit          → e besojmë ashtu si është
//   · mbi kufirin, por v/dpr  → e ndajmë me raportin e pikselave dhe e marrim
//     bie brenda kufirit        atë; kjo e kthen 186 në 62, jo në 64
//   · mbi kufirin dhe pas      → biem te kufiri; më mirë pak shumë se nën prerje
//     pjesëtimit prapë jashtë
//
// Nuk është mbulim gabimi. Është refuzim për të besuar një numër që s'mund të
// jetë i vërtetë — dhe, kur ka një shpjegim të vetëm të mundshëm për të, marrja
// e atij shpjegimi.
// ============================================================================

export const KUFI_LART = 64;
export const KUFI_POSHTE = 48;

// Format që lexon aplikacioni. Tri shtresa, me radhë:
//   1. `--safe-area-inset-*` — e shkruan `rregulloZonen()` më poshtë; te
//      Androidi e injekton edhe Capacitor vetë (WebView-t nën 140 e kthejnë
//      gabim `env()`).
//   2. `env(safe-area-inset-*)` — burimi standard.
//   3. `0px` — shfletuesi te kompjuteri, ku prerje nuk ka.
export const SAFE_TOP = "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))";
export const SAFE_BOTTOM = "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))";

// Të paktën `px` piksela, dhe kurrë më pak. Forma që duhet pothuajse kudo: një
// kokë do hapësirën e vet edhe kur prerje nuk ka.
export const sePakuLart = (px) => `max(${px}px, ${SAFE_TOP})`;
export const sePakuPoshte = (px) => `max(${px}px, ${SAFE_BOTTOM})`;

// ── Matja ───────────────────────────────────────────────────────────────────
// `env()` nuk lexohet dot me `getComputedStyle`: nuk është veti, është vlerë.
// E vetmja rrugë është t'ia japësh një elementi si `padding-top` dhe ta masësh
// atë element.
function mat(vlera) {
  try {
    if (typeof document === "undefined" || !document.body) return null;
    const el = document.createElement("div");
    el.style.cssText =
      "position:absolute;visibility:hidden;pointer-events:none;top:0;left:0;width:1px;height:0;padding-top:" + vlera;
    document.body.appendChild(el);
    const n = el.getBoundingClientRect().height;
    el.remove();
    return Number.isFinite(n) ? n : null;
  } catch (_e) { return null; }
}

// ── Gjykimi ─────────────────────────────────────────────────────────────────
//
// KORRIGJIM I NJË GABIMI TIM, po atë ditë. Versioni i parë e gjykonte vlerën e
// `env()`. Ai ishte vendi i gabuar për të parë.
//
// Zinxhiri që lexon aplikacioni është `var(--safe-area-inset-top, env(…))`, dhe
// `var()` FITON kur ndryshorja ekziston. Pra nëse dikush — Capacitor-i, një
// shtojcë, cilido — e shkruan atë ndryshore me një vlerë të prishur, `env()`
// mund të jetë krejt i saktë dhe faqja prapë të marrë numrin e gabuar.
//
// Kjo nuk është hollësi: është pikërisht rasti ku ndodhemi. Nëse `env` te
// iPhone-i kthen 62 (i saktë) kurse ndryshorja mban 186, versioni i parë do të
// thoshte «62, brenda kufirit — s'ka çka rregullohet» dhe do të largohej,
// ndërsa ekrani do të mbetej i prishur. Një rojtar që shikon nga dritarja e
// gabuar është më keq se asnjë rojtar, sepse të bind se ke kontrolluar.
//
// Prandaj gjykohet `efektivja` — ajo që merr vërtet faqja — dhe `env` mbahet si
// dëshmitar, sepse kur efektivja është e prishur, ai shpesh e di të vërtetën.
//
// Radha e preferencës:
//   1. efektivja brenda kufirit  → mos prek asgjë (rasti normal)
//   2. env brenda kufirit        → merre env (burimi i sistemit e di më mirë)
//   3. efektivja / dpr brenda    → ai është shpjegimi i vetëm i mundshëm
//   4. asnjëra                   → pritet te kufiri
export function gjyko(efektivja, env, kufi, dpr) {
  const e = Number.isFinite(efektivja) && efektivja >= 0 ? efektivja : null;
  const v = Number.isFinite(env) && env >= 0 ? env : null;
  if (e == null && v == null) return { vlera: 0, arsyeja: "s'u mat" };
  if (e != null && e <= kufi) return { vlera: Math.round(e), arsyeja: "brenda kufirit" };
  if (v != null && v <= kufi) return { vlera: Math.round(v), arsyeja: "u mor env" };
  const r = Number(dpr) > 1 && e != null ? e / Number(dpr) : NaN;
  if (Number.isFinite(r) && r <= kufi) return { vlera: Math.round(r), arsyeja: `pjesëtuar me ${dpr}` };
  return { vlera: kufi, arsyeja: "u pre te kufiri" };
}

// Çfarë raporton faqja tani — të tria vlerat, që të mos hamendësohet cila fiton.
export function lexoZonen() {
  return {
    envLart: mat("env(safe-area-inset-top, 0px)"),
    envPoshte: mat("env(safe-area-inset-bottom, 0px)"),
    perfLart: mat(SAFE_TOP),
    perfPoshte: mat(SAFE_BOTTOM),
    dpr: (typeof window !== "undefined" && window.devicePixelRatio) || 1,
  };
}

// ── Rregullimi ──────────────────────────────────────────────────────────────
// Shkruhet vetëm kur ka çka të rregullohet. Kur sistemi e jep vlerën saktë,
// kjo nuk prek asgjë — dhe kjo është e rëndësishme: një rregullim që ndërhyn
// edhe kur s'duhet, bëhet vetë burim defektesh nesër.
export function rregulloZonen() {
  if (typeof document === "undefined" || !document.documentElement) return null;
  const dpr = (typeof window !== "undefined" && window.devicePixelRatio) || 1;
  const rrenja = document.documentElement;
  const raport = { dpr, lart: null, poshte: null };

  for (const [emri, cssVar, zinxhiri, kufi] of [
    ["lart", "--safe-area-inset-top", SAFE_TOP, KUFI_LART],
    ["poshte", "--safe-area-inset-bottom", SAFE_BOTTOM, KUFI_POSHTE],
  ]) {
    // HEQJA E PARË ËSHTË E DOMOSDOSHME. Pa të, në thirrjen e dytë (rrotullim
    // ekrani) do të matnim vlerën që shkruam vetë herën e parë, do ta shihnim
    // brenda kufirit, dhe do të ngrinim atë numër përgjithmonë — edhe kur
    // prerja ka ndërruar anë.
    rrenja.style.removeProperty(cssVar);
    const efektivja = mat(zinxhiri);
    const env = mat(`env(safe-area-inset-${emri === "lart" ? "top" : "bottom"}, 0px)`);
    const g = gjyko(efektivja, env, kufi, dpr);
    raport[emri] = {
      efektivja: efektivja == null ? null : Math.round(efektivja),
      env: env == null ? null : Math.round(env),
      dole: g.vlera,
      arsyeja: g.arsyeja,
    };
    // Shkruhet vetëm kur e ndryshuam diçka. Kur sistemi e jep saktë, ndryshorja
    // mbetet e papërcaktuar — që Capacitor-i te Androidi ta mbajë të vetën.
    if (efektivja == null || Math.round(efektivja) !== g.vlera) {
      rrenja.style.setProperty(cssVar, g.vlera + "px");
    }
  }
  return raport;
}

// ── NUMRI, PËR ATA QË S'DUAN TË PRESIN CSS-NË ───────────────────────────────
//
// Kërkesë e pronarit, 29 gusht 2026: «view header-in ço lart edhe kryhet».
//
// Kishte të drejtë të mos priste më. Deri këtu, koka e dritares e merrte
// hapësirën përmes një zinxhiri CSS: `max(1rem, var(--…, env(…)))`. Ai zinxhir
// ka tri vende ku mund të japë diçka që s'e presim, dhe as njëri prej tyre nuk
// ankohet kur e jep — prandaj kaluam tri raunde duke hamendësuar se cili ishte.
//
// Ky funksion e mbyll atë temë për atë kokë: kthen një NUMËR, të matur dhe të
// gjykuar këtu, që i jepet drejtpërdrejt si piksel. Nëse numri është 62, koka
// merr 62. S'ka `var`, s'ka `env`, s'ka `max`, s'ka çka të bjerë në heshtje.
let _lartCache = null;
export function zonaLartPx() {
  if (_lartCache != null) return _lartCache;
  try {
    const dpr = (typeof window !== "undefined" && window.devicePixelRatio) || 1;
    const rrenja = document.documentElement;
    const ruajtur = rrenja.style.getPropertyValue("--safe-area-inset-top");
    rrenja.style.removeProperty("--safe-area-inset-top");
    const efektivja = mat(SAFE_TOP);
    const env = mat("env(safe-area-inset-top, 0px)");
    if (ruajtur) rrenja.style.setProperty("--safe-area-inset-top", ruajtur);
    _lartCache = gjyko(efektivja, env, KUFI_LART, dpr).vlera;
  } catch (_e) { _lartCache = 0; }
  return _lartCache;
}
export function harroZonen() { _lartCache = null; }

// Rrotullimi i ekranit e ndryshon zonën (prerja kalon anash). Ri-matim, por jo
// më shpesh se një kuadër — `resize` shkrepet me dhjetëra herë gjatë animacionit.
export function ndizRregulliminEZones() {
  let ne_pritje = false;
  const perseri = () => {
    if (ne_pritje) return;
    ne_pritje = true;
    requestAnimationFrame(() => {
      ne_pritje = false;
      harroZonen();
      try { rregulloZonen(); } catch (_e) { /* pa efekt */ }
    });
  };
  try { rregulloZonen(); } catch (_e) { /* pa efekt */ }
  if (typeof window !== "undefined") {
    window.addEventListener("resize", perseri);
    window.addEventListener("orientationchange", perseri);
  }
}
